import { useState } from 'react';
import type { Role } from '@frameio/graphql-client/generated';
import { useGetRolesForResource } from '../../../hooks/useGetRolesForResource';

export const useMemberAccessRoleSelect = ({
  resourceId,
  enabled = false,
}: {
  resourceId: string;
  enabled: boolean;
}) => {
  const [roleId, setCurrentRoleId] = useState<Role['id']>();

  const availableRoles = useGetRolesForResource({
    resourceId,
    fetchData: enabled,
  });

  const matchingRoleId = availableRoles?.find((role) => role.id === roleId)?.id;
  const firstRoleId = availableRoles?.[0]?.id;
  const currentRoleId = matchingRoleId || firstRoleId;

  return {
    availableRoles,
    currentRoleId,
    onChangeRole: setCurrentRoleId,
  };
};
